import { cva, type VariantProps } from 'class-variance-authority';

/**
 * DataPoint container styles: card padding, radius, border, and style/size variants.
 * All colors use design tokens (primary-*, secondary-*, neutral-*).
 */
export const datapointVariants = cva('rounded-md border h-full', {
  variants: {
    style: {
      primary:
        'bg-primary-50 border-primary-700 [&_svg]:text-primary-700 [&_[data-hen-icon]]:text-primary-700',
      secondary:
        'bg-secondary-50 border-secondary-700 [&_svg]:text-secondary-700 [&_[data-hen-icon]]:text-secondary-700',
      light: 'bg-neutral-50 border-neutral-200',
      borderless: 'border-none bg-transparent',
    },
    size: {
      sm: '[&_svg]:text-neutral-white [&_[data-hen-icon]]:text-neutral-white p-sm', // SM icon sits in dark pill
      lg: 'px-info-card-sides py-info-card-top-bottom ',
    },
  },
  defaultVariants: {
    style: 'primary',
    size: 'lg',
  },
});
